import { render, staticRenderFns } from "./SidebarRightLink.vue?vue&type=template&id=519f55ad"
import script from "./SidebarRightLink.vue?vue&type=script&lang=js"
export * from "./SidebarRightLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports